<template>
  <div class="mb-4">
    <div class="text-subtitle-2">
      {{ label }}:
    </div>
    <div class="text-subtitle-1 font-weight-medium">
      <template v-if="date">
        {{ date | datetime('YYYY-MM-DD h:mm a') }}
      </template>
      <template v-else>
        N/A
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: false,
    }
  }
}
</script>
